// extracted by mini-css-extract-plugin
export default {"datepicker":"DatePicker_datepicker__BAnGd"};